import { ScrollSpy } from 'bootstrap';
   
window.onload = () => {
    // 모바일용 상단 버튼
    const navbarToggler = document.getElementsByClassName('navbar-toggler')[0];
    // 모바일 용 텝 메뉴
    const responsiveNavItems = [].slice.call(document.querySelectorAll('#navbarResponsive .nav-link'));

    // ======================================== 상단 바 스크롤 이벤트 ========================================
    const navbarShrink = function () {
        const navbarCollapsible = document.body.querySelector('#mainNav');
        if (!navbarCollapsible) {
            return;
        }
        if (window.scrollY === 0) {
            navbarCollapsible.classList.remove('navbar-shrink')
        } else {
            navbarCollapsible.classList.add('navbar-shrink')
        }
    };
    document.addEventListener('scroll', navbarShrink);

    /// 부트스트랩 라이브러리 추가
    const mainNav = document.body.querySelector('#mainNav');
    if (mainNav) {
        new ScrollSpy(document.body, {
            target: '#mainNav',
            rootMargin: '0px 0px -40%',
        });
    };

    // 모바일 텝 메뉴 클릭시 이벤트
    responsiveNavItems.map((responsiveNavItem) => {
        responsiveNavItem.addEventListener('click', () => {
            if (window.getComputedStyle(navbarToggler).display !== 'none') {
                navbarToggler.click();
            }
        });
    });
}
